import { render, staticRenderFns } from "./statusWorkLeave.vue?vue&type=template&id=2572c87d&scoped=true&"
import script from "./statusWorkLeave.vue?vue&type=script&lang=js&"
export * from "./statusWorkLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2572c87d",
  null
  
)

export default component.exports